module.exports = __webpack_public_path__ + "static/media/fbbr12.65ce71ab.png";